import { NgModule } from '@angular/core';
import { CertemyCommonModule } from 'common/certemy-common.module';
import { StepDetailsModalComponent } from './step-details.modal.component';
import { StepHeaderModule } from './header/step-header.module';
import { FeesDetailsModalModule } from './fees-details/fees-details.modal.module';
import { ProfessionalLogModule } from './log-details/professional-log.module';
import { ResetConfirmModule } from './reset-confirm-content/reset-confirm-content.module';
import { DynamicDetailsComponent } from './dynamic-details/dynamic-details.modal.component';
import { EvidenceFileDetailsComponent } from './evidence-file-details/evidence-file-details.modal.component';
import { TestDetailsComponent } from './test-details/test-details.modal.component';
import { StatusIndicatorModule } from 'components/status-indicator/status-indicator.module';
import { DynamicFormModule } from 'components/dynamic-form/dynamic-form.module';
import { SignatureModule } from 'components/signature/signature.module';
import { InlineErrorModule } from 'components/errors/inline-error.module';
import {
  DatePickerModule,
  FileUploadModule,
  SelectModule,
  CheckboxGroupModule,
  RadioGroupModule,
  NumberInputModule,
  PreloaderModule,
  DisplayHtmlModule,
  CardModule,
} from '@certemy/ui-components';
import { ConfirmInfoModule } from 'components/upload-confirm/confirm-info.module';
import { StepOnBehalfListModule } from 'features/professional-step/shared/on-behalf-list/step-on-behalf-list.module';
import { InfoSectionModule } from 'components/info-section/info-section.module';
import { MultipleDynamicFormModule } from 'components/multiple-dynamic-form/multiple-dynamic-form.module';
import { EvidenceRequirementsComponent } from './evidence-file-details/modal-content/evidence-requirements/evidence-requirements.component';
import { UploadedDocumentsComponent } from './evidence-file-details/modal-content/uploaded-documents/uploaded-documents.component';
import { DynamicFormContentComponent } from './dynamic-details/modal-content/dynamic-content/dynamic-form-content.component';
import { DynamicSignatureComponent } from './dynamic-details/modal-content/signature-content/signature-content.component';
import { DynamicFormConfirmComponent } from './dynamic-details/modal-content/form-confirm-content/form-confirm-content.component';
import { CompleteContentComponent } from './registration-form-details/modal-content/complete-content/complete-content.component';
import { MultipleDynamicFormContentComponent } from './dynamic-details/modal-content/multiple-dynamic-form-content/multiple-dynamic-form-content.component';
import { DynamicFormContentDetailsComponent } from './dynamic-details/modal-content/dynamic-form-content-details/dynamic-form-content-details.component';
import { DraftFormsContentComponent } from './dynamic-details/modal-content/draft-forms-content/draft-forms-content.component';
import { DynamicFormContentSequenceComponent } from './dynamic-details/modal-content/dynamic-form-content-sequence/dynamic-form-content-sequence.component';
import { StepService } from 'services/professional/step/step.service';
import { PipesModule } from '@certemy/common';
import { TestRegistrationDetailsComponent } from './test-registration-details/test-registration-details.modal.component';
import { RegistrationFormConfirmComponent } from './registration-form-details/modal-content/confirm-content/confirm-content.component';
import { RegistrationFormDetailsComponent } from './registration-form-details/registration-form-details.modal.component';
import { TestRegistrationFormContentComponent } from './test-registration-details/test-registration-form-content/test-registration-form-content.component';
import { LicenseDetailsModalComponent } from 'components/modal-windows/step-details/license-details/license-details.modal.component';
import { OnboardingDetailsModalComponent } from 'components/modal-windows/step-details/onboarding-details/onboarding-details.modal.component';
import { NgbModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [
    CertemyCommonModule,
    StepHeaderModule,
    FeesDetailsModalModule,
    ProfessionalLogModule,
    ResetConfirmModule,
    StatusIndicatorModule,
    DynamicFormModule,
    SignatureModule,
    InlineErrorModule,
    DatePickerModule,
    FileUploadModule,
    ConfirmInfoModule,
    StepOnBehalfListModule,
    InfoSectionModule,
    SelectModule,
    CheckboxGroupModule,
    RadioGroupModule,
    NumberInputModule,
    PreloaderModule,
    DisplayHtmlModule,
    MultipleDynamicFormModule,
    CardModule,
    PipesModule,
    NgbModule,
    NgbTooltipModule,
  ],
  declarations: [
    StepDetailsModalComponent,
    DynamicDetailsComponent,
    EvidenceFileDetailsComponent,
    RegistrationFormDetailsComponent,
    TestDetailsComponent,
    EvidenceRequirementsComponent,
    UploadedDocumentsComponent,
    DynamicFormContentComponent,
    DynamicSignatureComponent,
    DynamicFormConfirmComponent,
    CompleteContentComponent,
    RegistrationFormConfirmComponent,
    MultipleDynamicFormContentComponent,
    DynamicFormContentDetailsComponent,
    DraftFormsContentComponent,
    DynamicFormContentSequenceComponent,
    TestRegistrationDetailsComponent,
    TestRegistrationFormContentComponent,
    LicenseDetailsModalComponent,
    OnboardingDetailsModalComponent,
  ],
  providers: [StepService],
})
export class StepDetailsModalModule {}
